<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card elevation="8" rounded="lg" class="text-center pa-6">
          <v-icon size="64" color="error" class="mb-4">
            mdi-shield-alert
          </v-icon>
          <h2 class="text-h4 font-weight-bold mb-2">
            {{ $t('common.noPermission') }}
          </h2>
          <p class="text-subtitle-1 text-medium-emphasis">
            {{ $t('common.contactAdmin') }}
          </p>
          <v-btn color="primary" class="mt-4" @click="goBack">
            {{ $t('common.goBack') }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goBack = () => {
  router.back()
}
</script>

<style scoped></style>
